import React from 'react';
import { MapLibre } from '@codesyntax/volto-maplibre-block/components/MapLibre/MapLibre';
import { MapLibreCounter } from '../../MapLibre/MapLibreCounter';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers';

const MaplibreBlockView = (props) => {
  const { data, className, style } = props;
  const center = {
    latitude: data?.latitude || '0.0',
    longitude: data?.longitude || '0.0',
    zoom: data?.zoom || 10,
  };
  const variation = data?.variation || 'default';

  // filter out items without correct values
  let markers =
    data?.markers?.filter((item) => item.latitude && item.longitude) || [];

  // console.log('MaplibreBlockView Custom', data)
  if (variation === 'counter') {
    return (
      <div className={cx('block maplibre', className)} style={style}>
        <MapLibreCounter
          markers={markers}
          center={center}
          height={data.height}
          tilesLayer={data.tilesLayer}
          fitBounds={data.fitbounds}
        />
      </div>
    );
  };
  return (
    <div className={cx('block maplibre', className)} style={style}>
      <MapLibre
        markers={markers}
        center={center}
        height={data.height}
        tilesLayer={data.tilesLayer}
        fitBounds={data.fitbounds}
      />
    </div>
  );
};

export default withBlockExtensions(MaplibreBlockView);
